module.exports = __webpack_public_path__ + "img/quotes-colton-cowell.0ba6451c.png";